module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "transition-expand-height"
    },
    on: {
      "enter": _vm.onEnter,
      "after-enter": _vm.onAfterEnter,
      "leave": _vm.onLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a31a7b8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ExpandHeight.vue
// module id = 250
// module chunks = 2